import type { MetaPaginationResponse } from "@/types";

export const QUERY_KEYS = {
	GET_MEMBER_PROFILE: "GET_MEMBER_PROFILE",
	GET_MEMBERS: "GET_MEMBERS",
	GET_MPIS_MEMBERS: "GET_MPIS_MEMBERS",
	GET_MEMBER: "GET_MEMBER",
	GET_MEMBER_HOME: "GET_MEMBER_HOME",
	GET_MEMBER_CHATS: "GET_MEMBER_CHATS",
	GET_MEMBER_CHATS_FLAT: "GET_MEMBER_CHATS_FLAT",
	GET_MY_ALERTS: "GET_MY_ALERTS",
	GET_MY_ALERTS_FLAT: "GET_MY_ALERTS_FLAT",
	GET_TEAMS: "GET_TEAMS",
	GET_TEAM: "GET_TEAM",
	GET_GROUPS: "GET_GROUPS",
	GET_GROUPS_FLAT: "GET_GROUPS_FLAT",
	GET_GROUP: "GET_GROUP",
	GET_CASES: "GET_CASES",
	GET_CASE_PDF_FILE: "GET_CASE_PDF_FILE",
	GET_CASE_LETTER_PDF_FILE: "GET_CASE_LETTER_PDF_FILE",
	GET_CASES_FLAT: "GET_CASES_FLAT",
	GET_PLAN: "GET_PLAN",
	GET_EVENT: "GET_EVENT",
	GET_CASE: "GET_CASE",
	GET_CASE_PATIENT_VISIT: "GET_CASE_PATIENT_VISIT",
	GET_CASE_PATIENT_VISITS: "GET_CASE_PATIENT_VISITS",
	GET_CASE_INFOS: "GET_CASE_INFOS",
	GET_CASE_PATIENT: "GET_CASE_PATIENT",
	GET_CASE_MEDICAL_NOTES: "GET_CASE_MEDICAL_NOTES",
	GET_UNREADS: "GET_UNREADS",
	GET_MARK_UNREADS: "GET_MARK_UNREADS",
	GET_MESSAGE: "GET_MESSAGE",
	GET_MESSAGES: "GET_MESSAGES",
	GET_DOCUMENTS: "GET_DOCUMENTS",
	GET_DOCUMENT: "GET_DOCUMENT",
	GET_ENCOUNTER: "GET_ENCOUNTER",
	GET_STORAGES: "GET_STORAGES",
	GET_REMINDERS: "GET_REMINDERS",
	GET_REMINDERS_FLAT: "GET_REMINDERS_FLAT",
	GET_REMINDER: "GET_REMINDER",
	GET_HEMI_MESSAGES: "GET_HEMI_MESSAGES",
	GET_HEMI_RESPONSE_MESSAGE: "GET_HEMI_RESPONSE_MESSAGE",
	GET_CALENDARS: "GET_CALENDARS",
	GET_CALENDAR_INFO: "GET_CALENDAR_INFO",
	GET_CALENDARS_DETAIL: "GET_CALENDARS_DETAIL",
	GET_BULLETINS: "GET_BULLETINS",
	GET_BULLETINS_FLAT: "GET_BULLETINS_FLAT",
	GET_BULLETIN_GROUPS: "GET_BULLETIN_GROUPS",
	GET_BULLETIN_SUBSCRIPTION_GROUPS: "GET_BULLETIN_SUBSCRIPTION_GROUPS",
	GET_CASE_LETTER: "GET_CASE_LETTER",
	GET_CASE_LETTERS: "GET_CASE_LETTERS",
	MUTATE_CASE_SEND_EMAIL: "MUTATE_CASE_SEND_EMAIL",
	MUTATE_AUTH_LOGIN: "MUTATE_AUTH_LOGIN",
	MUTATE_AUTH_LOGIN_SSO: "MUTATE_AUTH_LOGIN_SSO",
	MUTATE_AUTH_REGISTER: "MUTATE_AUTH_REGISTER",
	MUTATE_EVENT_CREATE: "MUTATE_EVENT_CREATE",
	MUTATE_EVENT_UPDATE: "MUTATE_EVENT_UPDATE",
	MUTATE_EVENT_REMOVE: "MUTATE_EVENT_REMOVE",
	MUTATE_EVENT_COPY: "MUTATE_EVENT_COPY",
	MUTATE_CASE_SYNC: "MUTATE_CASE_SYNC",
	MUTATE_CASE_ASSIGN_TEAM: "MUTATE_CASE_ASSIGN_TEAM",
	MUTATE_CASE_UNASSIGN_TEAM: "MUTATE_CASE_UNASSIGN_TEAM",
	MUTATE_CASE_REQUEST_ACCESS: "MUTATE_CASE_REQUEST_ACCESS",
	MUTATE_CASE_CREATE: "MUTATE_CASE_CREATE",
	MUTATE_CASE_UPDATE: "MUTATE_CASE_UPDATE",
	MUTATE_CASE_LEAVE: "MUTATE_CASE_LEAVE",
	MUTATE_CASE_CLOSED: "MUTATE_CASE_CLOSED",
	MUTATE_CASE_REOPEN: "MUTATE_CASE_REOPEN",
	MUTATE_CASE_ADD_MEMBER: "MUTATE_CASE_ADD_MEMBER",
	MUTATE_CASE_REMOVE_MEMBER: "MUTATE_CASE_REMOVE_MEMBER",
	MUTATE_CASE_ASSIGN_PATIENT: "MUTATE_CASE_ASSIGN_PATIENT",
	MUTATE_CASE_ADD_PATIENT_LOCATION: "MUTATE_CASE_ADD_PATIENT_LOCATION",
	MUTATE_CHECK_PATIENT_IN_CASE: "MUTATE_CHECK_PATIENT_IN_CASE",
	MUTATE_PATIENT_CREATE: "MUTATE_PATIENT_CREATE",
	MUTATE_PATIENT_UPDATE: "MUTATE_PATIENT_UPDATE",
	MUTATE_PATIENT_VISIT_CREATE: "MUTATE_PATIENT_VISIT_CREATE",
	MUTATE_PATIENT_VISIT_UPDATE: "MUTATE_PATIENT_VISIT_UPDATE",
	MUTATE_CASE_INFO_CREATE: "MUTATE_CASE_INFO_CREATE",
	MUTATE_MEMBER_UPDATE: "MUTATE_MEMBER_UPDATE",
	MUTATE_MEMBER_SYNC_CHAT: "MUTATE_MEMBER_SYNC_CHAT",
	MUTATE_VERIFY_PHONE_NUMBER: "MUTATE_VERIFY_PHONE_NUMBER",
	MUTATE_VERIFY_RESEND_PHONE_NUMBER: "MUTATE_VERIFY_RESEND_PHONE_NUMBER",
	MUTATE_VERIFY_PHONE_CODE: "MUTATE_VERIFY_PHONE_CODE",
	MUTATE_GROUP_CREATE: "MUTATE_GROUP_CREATE",
	MUTATE_GROUP_UPDATE: "MUTATE_GROUP_UPDATE",
	MUTATE_GROUP_CLOSE: "MUTATE_GROUP_CLOSE",
	MUTATE_GROUP_SYNC: "MUTATE_GROUP_SYNC",
	MUTATE_PREVIEW_URL: "MUTATE_PREVIEW_URL",
	MUTATE_UPLOAD_IMAGES: "MUTATE_UPLOAD_IMAGES",
	MUTATE_DELETE_IMAGE: "MUTATE_DELETE_IMAGE",
	MUTATE_DELETE_IMAGES: "MUTATE_DELETE_IMAGES",
	MUTATE_EXPORT_IMAGES: "MUTATE_EXPORT_IMAGES",
	MUTATE_CREATE_MESSAGE: "MUTATE_CREATE_MESSAGE",
	MUTATE_UPDATE_MESSAGE: "MUTATE_UPDATE_MESSAGE",
	MUTATE_DELETE_MESSAGE: "MUTATE_DELETE_MESSAGE",
	MUTATE_READ_MESSAGE: "MUTATE_READ_MESSAGE",
	MUTATE_SYNC_MESSAGE: "MUTATE_SYNC_MESSAGE",
	MUTATE_SYNC_INBOX_MESSAGES: "MUTATE_SYNC_INBOX_MESSAGES",
	MUTATE_CREATE_CHANNEL: "MUTATE_CREATE_CHANNEL",
	MUTATE_MEMBER_INVITATION: "MUTATE_MEMBER_INVITATION",
	MUTATE_REMINDER_CHECK: "MUTATE_REMINDER_CHECK",
	MUTATE_REMINDER_CREATE: "MUTATE_REMINDER_CREATE",
	MUTATE_REMINDER_UPDATE: "MUTATE_REMINDER_UPDATE",
	MUTATE_REMINDER_DELETE: "MUTATE_REMINDER_DELETE",
	MUTATE_BULLETIN_SUBSCRIBE: "MUTATE_BULLETIN_SUBSCRIBE",
	MUTATE_CREATE_HEMI_MESSAGE: "MUTATE_CREATE_HEMI_MESSAGE",
	MUTATE_TEAM_CREATE: "MUTATE_TEAM_CREATE",
	MUTATE_TEAM_UPDATE: "MUTATE_TEAM_UPDATE",
	MUTATE_TEAM_LEAVE: "MUTATE_TEAM_LEAVE",
	MUTATE_TEAM_CASE_EXTERNAL: "MUTATE_TEAM_CASE_EXTERNAL",
	MUTATE_CASE_ENCOUNTER_CREATE: "MUTATE_CASE_ENCOUNTER_CREATE",
	MUTATE_MESSAGE_ACCEPT: "MUTATE_MESSAGE_ACCEPT",
	MUTATE_MESSAGE_DECLINE: "MUTATE_MESSAGE_DECLINE",
	GET_ASKHEMI_SHARE: "GET_ASKHEMI_SHARE",
	GET_CARE_CHAT: "GET_CARE_CHAT",
	GET_CARE_CHAT_MESSAGES: "GET_CARE_CHAT_MESSAGES",
	GET_WOUND_ANALYSIS: "GET_WOUND_ANALYSIS",
	GET_WOUND_ANALYSES: "GET_WOUND_ANALYSES",
	GET_CASE_ASKHEMI_PROFILE: "GET_CASE_ASKHEMI_PROFILE",
	MUTATE_START_CARE_CHAT: "MUTATE_START_CARE_CHAT",
	MUTATE_CLOSE_CARE_CHAT: "MUTATE_CLOSE_CARE_CHAT",
	MUTATE_SEND_CARE_CHAT_MESSAGE: "MUTATE_SEND_CARE_CHAT_MESSAGE",
	MUTATE_CREATE_WOUND_ANALYSIS: "MUTATE_CREATE_WOUND_ANALYSIS",
	MUTATE_CREATE_CASE_MEDICAL_NOTES: "MUTATE_CREATE_CASE_MEDICAL_NOTES",
	MUTATE_UPDATE_CASE_MEDICAL_NOTES: "MUTATE_UPDATE_CASE_MEDICAL_NOTES",
	MUTATE_DELETE_CASE_MEDICAL_NOTES: "MUTATE_DELETE_CASE_MEDICAL_NOTES",
	MUTATE_SIGN_CASE_MEDICAL_NOTE: "MUTATE_SIGN_CASE_MEDICAL_NOTE",
	MUTATE_CASE_LETTERS_CREATE_NOTES: "MUTATE_CASE_LETTERS_CREATE_NOTES",
	MUTATE_CASE_LETTERS_UPDATE_NOTES: "MUTATE_CASE_LETTERS_UPDATE_NOTES",
	MUTATE_CASE_LETTERS_DELETE_NOTES: "MUTATE_CASE_LETTERS_DELETE_NOTES",
	MUTATE_CASE_LETTERS_EMAIL_NOTES: "MUTATE_CASE_LETTERS_EMAIL_NOTES",
} as const;

/**
 * @description Key for local storage
 */
export const STORAGE_KEYS = {
	FORM_CREDENTIALS: "formCredentials",
	FORM_VERIFY_MOBILE_PHONE_NUMBER: "phone_number",
	FORM_VERIFY_MOBILE_VERIFY_CODE: "verify_code",
	PERSIST_SYNC_STORAGE: "persistSyncStorage",
	SESSION_PERSIST_CREATE_CASE: "sessionPersistCreateCase",
} as const;

export const DOWNLOAD_LINKS = {
	APP_STORE:
		"https://apps.apple.com/id/app/medplanner-clinical-messaging/id1464981072",
	PLAY_STORE: "https://play.google.com/store/apps/details?id=io.medplanner.app",
} as const;

export const CONTACT_DIRECTORY_SCOPE = {
	ALL_TEAMS: "all_teams",
	CASE_TEAMS: "case_teams",
	INTEREST_GROUPS: "interest_groups",
	EXTERNAL: "external",
} as const;

export type ContactDirectoryScope =
	(typeof CONTACT_DIRECTORY_SCOPE)[keyof typeof CONTACT_DIRECTORY_SCOPE];

export const SUBSCRIPTION_STATUS = {
	Free: "free",
	FreeTrial: "free_trial",
	PREMIUM: "premium",
	PLUS: "plus",
	PRO: "pro",
} as const;

export type SubscriptionStatus =
	(typeof SUBSCRIPTION_STATUS)[keyof typeof SUBSCRIPTION_STATUS];

export const USER_STATUS = {
	Available: "available",
	Busy: "busy",
	OffDuty: "off duty",
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];

export const emptyMetaData: MetaPaginationResponse = {
	current_page: 1,
	next_page: null,
	prev_page: null,
	total_count: 1,
	total_pages: 1,
};

export const defaultMetaData: MetaPaginationResponse = {
	current_page: 1,
	next_page: null,
	prev_page: null,
	total_count: 0,
	total_pages: 1,
};

export const IMAGE_MIME_TYPE = {
	PNG: "image/png",
	JPEG: "image/jpeg",
	JPG: "image/jpg",
	GIF: "image/gif",
} as const;

export const IMAGE_EXTENSIONS = {
	PNG: ".png",
	JPEG: ".jpeg",
	JPG: ".jpg",
	GIF: ".gif",
} as const;

export const DOCUMENT_MIME_TYPE = {
	PDF: "application/pdf",
	DOC: "application/msword",
	DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	XLS: "application/vnd.ms-excel",
	XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	PPT: "application/vnd.ms-powerpoint",
	PPTX: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
} as const;

export const ACCEPT_DOC_TYPE_MESSAGE = [
	DOCUMENT_MIME_TYPE.PDF,
	DOCUMENT_MIME_TYPE.DOC,
	DOCUMENT_MIME_TYPE.DOCX,
] as const;

export const ACCEPT_DOC_AND_MEDIA_TYPE_MESSAGE = [
	"image/*",
	"video/*",
	DOCUMENT_MIME_TYPE.PDF,
	DOCUMENT_MIME_TYPE.DOC,
	DOCUMENT_MIME_TYPE.DOCX,
] as const;

export const subscriptionRules = {
	maxCase: {
		[SUBSCRIPTION_STATUS.Free]: 5,
		[SUBSCRIPTION_STATUS.PLUS]: 30,
	},
	subsBulletin: {
		[SUBSCRIPTION_STATUS.Free]: 3,
	},
} as const;

export const TEAMS_SCOPE = {
	ALL: "all_teams",
	TEAM: "case_teams",
	GROUP: "interest_groups",
	EXTERNAL: "external",
} as const;

export const supportedImageExtensions = [
	".jpg",
	".jpeg",
	".png",
	".gif",
	".webp",
	".bmp",
	".svg",
	".ico",
	".apng",
	".avif",
	".tiff",
	".tif",
	".heic",
] as const;

export const allFileExtensionToMime = {
	".aac": "audio/aac",
	".abw": "application/x-abiword",
	".apng": "image/apng",
	".arc": "application/x-freearc",
	".avif": "image/avif",
	".avi": "video/x-msvideo",
	".azw": "application/vnd.amazon.ebook",
	".bin": "application/octet-stream",
	".bmp": "image/bmp",
	".bz": "application/x-bzip",
	".bz2": "application/x-bzip2",
	".cda": "application/x-cdf",
	".csh": "application/x-csh",
	".css": "text/css",
	".csv": "text/csv",
	".doc": "application/msword",
	".docx":
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	".eot": "application/vnd.ms-fontobject",
	".epub": "application/epub+zip",
	".gz": "application/gzip",
	".gif": "image/gif",
	".html": "text/html",
	".ico": "image/vnd.microsoft.icon",
	".ics": "text/calendar",
	".jar": "application/java-archive",
	".jpeg": "image/jpeg",
	".jpg": "image/jpeg",
	".js": "text/javascript",
	".json": "application/json",
	".jsonld": "application/ld+json",
	".mid": "audio/midi",
	".midi": "audio/midi",
	".mjs": "text/javascript",
	".mp3": "audio/mpeg",
	".mp4": "video/mp4",
	".mpeg": "video/mpeg",
	".mpkg": "application/vnd.apple.installer+xml",
	".odp": "application/vnd.oasis.opendocument.presentation",
	".ods": "application/vnd.oasis.opendocument.spreadsheet",
	".odt": "application/vnd.oasis.opendocument.text",
	".oga": "audio/ogg",
	".ogv": "video/ogg",
	".ogx": "application/ogg",
	".opus": "audio/opus",
	".otf": "font/otf",
	".png": "image/png",
	".pdf": "application/pdf",
	".php": "application/x-httpd-php",
	".ppt": "application/vnd.ms-powerpoint",
	".pptx":
		"application/vnd.openxmlformats-officedocument.presentationml.presentation",
	".rar": "application/vnd.rar",
	".rtf": "application/rtf",
	".sh": "application/x-sh",
	".svg": "image/svg+xml",
	".tar": "application/x-tar",
	".tiff": "image/tiff",
	".tif": "image/tiff",
	".ts": "video/mp2t",
	".ttf": "font/ttf",
	".txt": "text/plain",
	".vsd": "application/vnd.visio",
	".wav": "audio/wav",
	".weba": "audio/webm",
	".webm": "video/webm",
	".webp": "image/webp",
	".woff": "font/woff",
	".woff2": "font/woff2",
	".xhtml": "application/xhtml+xml",
	".xls": "application/vnd.ms-excel",
	".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	".xml": "application/xml",
	".xul": "application/vnd.mozilla.xul+xml",
	".zip": "application/zip",
	".3gp": "video/3gpp; audio/3gpp",
	".3g2": "video/3gpp2; audio/3gpp2",
	".7z": "application/x-7z-compressed",
} as const;

export type ExtensionToMime = typeof allFileExtensionToMime;

export const ASPECT_RATIO = {
	"3:4": 3 / 4,
	"9:16": 9 / 16,
	"1:1": 1 / 1,
} as const;

export const CASE_MEMBER_TYPE = {
	EXTERNAL_REQUEST_MEMBER: "external_request_member",
	EXTERNAL_MEMBER: "external_member",
	INTERNAL_MEMBER: "internal_member",
	NOT_MEMBER: "not_member",
} as const;

export const LETTER_TYPE = {
	REFERRAL_LETTER: "referral_letter",
	DISCHARGE_LETTER: "discharge_letter",
	OTHER_LETTER: "other_letter",
} as const;

export const LETTER_TYPE_VALUE = {
	[LETTER_TYPE.REFERRAL_LETTER]: "Referral Letter",
	[LETTER_TYPE.DISCHARGE_LETTER]: "Discharge Letter",
	[LETTER_TYPE.OTHER_LETTER]: "Letter (Other)",
} as const;
